import putjs from "put-js";
import appConfig from '../config';


// export putjs
export default (loadState) => {
  const { account } = loadState;

  // this is putjs config
  let config = {
    account_name: account.name,
    eos_endpoint: appConfig.eos_endpoint,
    put_endpoint: appConfig.put_endpoint,
    copayment: true
  };

  // key provided, add key to config
  if (account.key) config.account_pk = account.key;

  return new putjs(config);
};
